import {
    Organizations, Account,
} from '@/screens'

import Dashboard from '@/layouts/Dashboard.vue'

export default () => [
    {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        redirect: { name: 'Organizations' },
        children: [
            {
                path: 'organizations',
                name: 'Organizations',
                component: Organizations,
                meta: {
                    header: true,
                    search: true,
                },
            },
            {
                path: 'account',
                name: 'Account',
                component: Account,
                meta: {
                    header: true,
                    search: false,
                },
            },
            {
                path: 'doc',
                name: 'Doc',
                component: Account,
                meta: {
                    header: true,
                    search: false,
                },
            },
        ],
    },
]
